import step1 from './01.svg'
import step2 from './02.svg'
import step3 from './03.svg'
import step4 from './04.svg'
import step5 from './05.svg'
import step6 from './06.svg'

const steps = [
  {
    trans: 'gamify:tutorial.step1',
    img: step1,
  },{
    trans: 'gamify:tutorial.step2',
    img: step2,
    areas: [{
      x: 41.06, //% from left image border to left border of area
      y: 15.06,  //% from top image border to top of the area
      w: 17.55, //width in % relative to image
      r: 2.51, //height in % of image width
    }],
  },{
    trans: 'gamify:tutorial.step3',
    img: step3,
  },{
    trans: 'gamify:tutorial.step4',
    img: step4,
    areas: [{
      x: 10.31,
      y: 85.66,
      w: 19.85,
      r: 2.73,
    }],
  },{
    trans: 'gamify:tutorial.step5',
    img: step5,
    areas: [{
      x: 36.63,
      y: 24.68,
      w: 27.51,
      r: 3.75,
    }],
  },{
    trans: 'gamify:tutorial.step6',
    img: step6,
    areas: [{
      x: 39.61,
      y: 57.17,
      w: 20.87,
      r: 3.75,
    }],
  },
];

export default steps;


// WEBPACK FOOTER //
// ./src/apps/gamify/tutorial/index.js